module.exports = __webpack_public_path__ + "img/1582650373.5dcb8ec4.jpg";